import { createSlice } from '@reduxjs/toolkit';
import { attachDetachUserToClass } from './Utils/ClassUtils';

const initialState = {
    class_id: '',
    membershipId: '',
    userId: [],
    isLoading: false,
};

const attachDetachUserToClassSlice = createSlice(
    {
        name: 'attachDetachUserToClass',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(attachDetachUserToClass.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(attachDetachUserToClass.fulfilled, (state, action) => {
                    // Handle success state
                    state.isLoading = false;
                })
                .addCase(attachDetachUserToClass.rejected, (state, action) => {
                    // Handle error state
                    state.isLoading = false;
                });
        }
    }
);

export const { setField, resetState } = attachDetachUserToClassSlice.actions;

export default attachDetachUserToClassSlice.reducer;